import { jsx as _jsx } from "react/jsx-runtime";
import { useFinalRequest } from '@zenlayer/portal-utils';
import { Textarea } from '@zenlayer/zen-design';
import { pickDomAttrs } from '@zenlayer/zen-design/esm/_util/utils';
import t from '@zenlayer/zen-intl18';
import { useEffect, useState } from 'react';
export const NoteTextArea = ({ label, width = '100%', maxLength = 128, showCount = true, value, auth, onSubmit, className, style, ...restProps }) => {
    const attrs = pickDomAttrs(restProps);
    value = value?.toString() || '';
    const [originalValue, setOriginalValue] = useState(value);
    const [inputValue, setInputValue] = useState(value);
    const submitReq = useFinalRequest(async (v) => {
        return await onSubmit(v);
    }, {
        manual: true,
        onSuccess(res, params) {
            if (res) {
                setOriginalValue(params[0]);
            }
            return res;
        },
    });
    useEffect(() => {
        setOriginalValue(value);
        setInputValue(value);
    }, [value]);
    return (_jsx("div", { className: className, style: { ...style, width }, children: auth ? (_jsx(Textarea, { ...restProps, type: "filled", width: "100%", label: label ?? t('OTvMCejZ2AI1'), maxLength: maxLength, showCount: showCount, value: inputValue, onChange: setInputValue, onBlur: () => {
                if (originalValue !== inputValue || submitReq.data === false) {
                    submitReq.run(inputValue);
                }
            } })) : (originalValue) }));
};
